import { SHOP as STATIC_SHOP } from "@/data/products";

let currentShop = STATIC_SHOP;
export const setShopRef = (s) => { if (s?.phone) currentShop = s; };

export const detectSource = () => {
  if (typeof window === "undefined") return "site";
  try {
    const params = new URLSearchParams(window.location.search);
    const via = params.get("via");
    if (via === "qr-fr") { window.sessionStorage.setItem("oss-source", "qr-fr"); return "qr-fr"; }
    if (via === "qr") { window.sessionStorage.setItem("oss-source", "qr"); return "qr"; }
    const cached = window.sessionStorage.getItem("oss-source");
    if (cached === "qr-fr" || cached === "qr") return cached;
    return "site";
  } catch { return "site"; }
};

export const buildSms = ({ categoryId, itemName, body: customBody, noRef } = {}) => {
  if (customBody) {
    return `sms:${currentShop.phone}?&body=${encodeURIComponent(customBody)}`;
  }
  const source = detectSource();
  const ref = noRef ? "" : ` [ref=${source}-${categoryId || "general"}]`;
  const item = itemName ? ` (${itemName})` : "";
  const cat = categoryId ? ` regarding ${categoryId.replace(/-/g, " ")}${item}` : "";
  const body = `Hey OSS — I'd like to place an order${cat}.${ref}`;
  return `sms:${currentShop.phone}?&body=${encodeURIComponent(body)}`;
};

export const telHref = () => `tel:${currentShop.phone}`;
